import { createContext, useContext, useState, useEffect } from "react";
import ApiManager from "../ApiManager/ApiManager";
import { getLoadingInstance } from "./LoadingProvider";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userPermissions")) || [];
    } catch (error) {
      console.error("Error parsing userPermissions from localStorage", error);
      return [];
    }
  });

  const [vendorDetails, setVendorDetails] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vendorDetails")) || null;
    } catch (error) {
      console.error("Error parsing vendorDetails from localStorage", error);
      return null;
    }
  });

  useEffect(() => {
    console.log("AuthProvider Mounted - User Permissions:", userPermissions);
    console.log("AuthProvider Mounted - Vendor Details:", vendorDetails);
  }, [userPermissions, vendorDetails]);

  const login = async (params) => {
    try {
      const response = await ApiManager.login(params);
      const data = await response.json();

      if (!data.token) throw new Error("Token not found");

      localStorage.setItem("authToken", data.token);

      const permissionsRes = await ApiManager.getAllPermissions();
      const permissionsData = await permissionsRes.json();
      const givenPermissions = permissionsData.map((p) => p.name);

      localStorage.setItem("userPermissions", JSON.stringify(givenPermissions));
      setUserPermissions(givenPermissions);
      
      const vendorRes = await ApiManager.getVendor();
      const vendorData = await vendorRes.json();

      console.log("Login - Vendor Details:", vendorData);

      localStorage.setItem("vendorDetails", JSON.stringify(vendorData));
      setVendorDetails(vendorData);

      return true;
    } catch (error) {
      console.error("Login error:", error);
      return false;
    }
  };

  const logout = async () => {
    try {
      console.log("Logging out - Calling API...");
      const response = await ApiManager.logout(null);

      if (!response.ok) throw new Error("Logout API failed");

      console.log("Logout successful - Clearing user data...");
      localStorage.removeItem("authToken");
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("vendorDetails");
      setUserPermissions([]);
      setVendorDetails(null);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ userPermissions, vendorDetails, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
